import { Button, Chip, CloseIcon, Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserConfigContext } from '../../../hooks/useUserConfigContext';
import { InheritDeputateForm } from '../forms/InheritDeputateForm';
import styles from './InheritDeputateModal.module.scss';

type InheritDeputateModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const InheritDeputateModal = ({ isOpen, onClose }: InheritDeputateModalProps) => {
  const { t } = useTranslation();
  const previousSchoolYear = useUserConfigContext().previousSchoolYear;

  const [loading, setLoading] = useState(false);

  return (
    <Modal
      className={styles['inherit-deputate-modal']}
      customHeader={
        <div className={styles.header}>
          <div className={styles.title}>{t('common.inheritFromPreviousYear')}</div>
          {previousSchoolYear && <Chip className={styles.chip} value={previousSchoolYear.shortName} />}
          <Button className={styles.button} hierarchy='tertiary' icon={<CloseIcon />} onClick={onClose} />
        </div>
      }
      isOpen={isOpen}
      onRequestClose={onClose}
      loading={loading}
    >
      <InheritDeputateForm onClose={onClose} onLoad={setLoading} />
    </Modal>
  );
};
